const recapI18n = {
  "fr": {
    "header": {
      "title": "Récapitulatif de votre sélection",
      "subtitle": "Vérifiez vos articles avant de poursuivre."
    },
    "chips": {
      "devices": "Appareils :",
      "parts": "Pièces :",
      "totalHT": "Total HT :"
    },
    "count": {
      "devices": "Appareils",
      "parts": "Pièces détachées",
      "totalItems": "Total pièces"
    },
    "total": "Total",
    "empty": {
      "text": "Aucune sélection en cours.",
      "back": "Retour aux tarifs"
    },
    "table": {
      "aria": "détail récapitulatif",
      "article": "Article",
      "unit": "PU (€)",
      "qty": "Qté",
      "total": "Total (€)",
      "typeDevice": "Appareil complet",
      "typePart": "Pièce détachée",
      "totalHT": "Total HT"
    },
    "actions": {
      "editSelection": "Modifier ma sélection",
      "validate": "Valider"
    },
    "confirm": {
      "title": "Confirmation du paiement",
      "savedIbanTitle": "IBAN enregistré",
      "body": "Nous utiliserons cet IBAN pour déclencher le virement une fois le contrôle qualité de vos pièces terminé.",
      "changeIban": "Modifier l’IBAN"
    },
    "iban": {
      "title": "Coordonnées IBAN",
      "info": "Cet IBAN sera utilisé pour votre paiement après contrôle qualité de vos pièces.",
      "ownerLabel": "Titulaire du compte (facultatif)",
      "ibanLabel": "IBAN",
      "helper": "Nous acceptons les IBAN de l’Espace SEPA.",
      "saveAndConfirm": "Enregistrer et valider"
    },
    "common": {
      "cancel": "Annuler",
      "confirm": "Confirmer"
    },
    "errors": {
      "invalidIban": "IBAN invalide. Vérifiez le format et la clé (mod 97).",
      "saveFailed": "Impossible d’enregistrer l’IBAN."
    },
    "labels": {
      "screen": "Écran",
      "motherboard": "Carte mère",
      "battery": "Batterie",
      "camera": "Caméra",
      "speaker": "Haut-parleur",
      "microphone": "Micro",
      "chargingConnector": "Connecteur de charge",
      "button": "Bouton",
      "vibrator": "Vibreur",
      "packages": "colis",
      "kg": "kg",
      "pieces": "pièces",
      "batchSort": "Envoie, on trie pour toi !"
    }
  },
  "en": {
    "header": {
      "title": "Your selection summary",
      "subtitle": "Check your items before proceeding."
    },
    "chips": {
      "devices": "Devices:",
      "parts": "Parts:",
      "totalHT": "Subtotal:"
    },
    "count": {
      "devices": "Devices",
      "parts": "Spare parts",
      "totalItems": "Total items"
    },
    "total": "Total",
    "empty": {
      "text": "No selection in progress.",
      "back": "Back to pricing"
    },
    "table": {
      "aria": "summary details",
      "article": "Item",
      "unit": "Unit (€)",
      "qty": "Qty",
      "total": "Total (€)",
      "typeDevice": "Complete device",
      "typePart": "Spare part",
      "totalHT": "Subtotal"
    },
    "actions": {
      "editSelection": "Edit my selection",
      "validate": "Confirm"
    },
    "confirm": {
      "title": "Payment confirmation",
      "savedIbanTitle": "Saved IBAN",
      "body": "We will use this IBAN to make the transfer after the quality check of your items.",
      "changeIban": "Change IBAN"
    },
    "iban": {
      "title": "IBAN details",
      "info": "This IBAN will be used for your payment after the quality check of your items.",
      "ownerLabel": "Account holder (optional)",
      "ibanLabel": "IBAN",
      "helper": "We accept SEPA IBANs.",
      "saveAndConfirm": "Save and confirm"
    },
    "common": {
      "cancel": "Cancel",
      "confirm": "Confirm"
    },
    "errors": {
      "invalidIban": "Invalid IBAN. Check the format and checksum (mod 97).",
      "saveFailed": "Unable to save IBAN."
    },
    "labels": {
      "screen": "Screen",
      "motherboard": "Mainboard",
      "battery": "Battery",
      "camera": "Camera",
      "speaker": "Speaker",
      "microphone": "Microphone",
      "chargingConnector": "Charging connector",
      "button": "Taste",
      "vibrator": "Vibrationsmotor",
      "packages": "parcels",
      "kg": "kg",
      "pieces": "pcs",
      "batchSort": "Send it, we sort it for you!"
    }
  },
  "es": {
    "header": {
      "title": "Resumen de tu selección",
      "subtitle": "Verifica tus artículos antes de continuar."
    },
    "chips": {
      "devices": "Dispositivos:",
      "parts": "Piezas:",
      "totalHT": "Subtotal:"
    },
    "count": {
      "devices": "Dispositivos",
      "parts": "Piezas de repuesto",
      "totalItems": "Total de artículos"
    },
    "total": "Total",
    "empty": {
      "text": "No hay ninguna selección en curso.",
      "back": "Volver a precios"
    },
    "table": {
      "aria": "detalles del resumen",
      "article": "Artículo",
      "unit": "Precio (€)",
      "qty": "Cant.",
      "total": "Total (€)",
      "typeDevice": "Dispositivo completo",
      "typePart": "Pieza de repuesto",
      "totalHT": "Subtotal"
    },
    "actions": {
      "editSelection": "Modificar mi selección",
      "validate": "Confirmar"
    },
    "confirm": {
      "title": "Confirmación del pago",
      "savedIbanTitle": "IBAN guardado",
      "body": "Usaremos este IBAN para realizar la transferencia una vez finalice el control de calidad de tus piezas.",
      "changeIban": "Cambiar IBAN"
    },
    "iban": {
      "title": "Datos del IBAN",
      "info": "Este IBAN se utilizará para tu pago después del control de calidad de tus piezas.",
      "ownerLabel": "Titular de la cuenta (opcional)",
      "ibanLabel": "IBAN",
      "helper": "Aceptamos IBAN del espacio SEPA.",
      "saveAndConfirm": "Guardar y confirmar"
    },
    "common": {
      "cancel": "Cancelar",
      "confirm": "Confirmar"
    },
    "errors": {
      "invalidIban": "IBAN no válido. Comprueba el formato y el dígito de control (mod 97).",
      "saveFailed": "No se pudo guardar el IBAN."
    },
    "labels": {
      "screen": "Pantalla",
      "motherboard": "Placa base",
      "battery": "Batería",
      "camera": "Cámara",
      "speaker": "Altavoz",
      "microphone": "Micrófono",
      "chargingConnector": "Conector de carga",
      "button": "Botón",
      "vibrator": "Vibrador",
      "packages": "paquetes",
      "kg": "kg",
      "pieces": "uds.",
      "batchSort": "¡Envíalo, lo clasificamos por ti!"
    }
  },
  "pl": {
    "header": {
      "title": "Podsumowanie wyboru",
      "subtitle": "Sprawdź pozycje przed kontynuacją."
    },
    "chips": {
      "devices": "Urządzenia:",
      "parts": "Części:",
      "totalHT": "Suma netto:"
    },
    "count": {
      "devices": "Urządzenia",
      "parts": "Części zamienne",
      "totalItems": "Razem sztuk"
    },
    "total": "Suma",
    "empty": {
      "text": "Brak bieżącego wyboru.",
      "back": "Powrót do cennika"
    },
    "table": {
      "aria": "szczegóły podsumowania",
      "article": "Pozycja",
      "unit": "Cena jedn. (€)",
      "qty": "Ilość",
      "total": "Razem (€)",
      "typeDevice": "Urządzenie kompletne",
      "typePart": "Część zamienna",
      "totalHT": "Suma netto"
    },
    "actions": {
      "editSelection": "Zmień mój wybór",
      "validate": "Zatwierdź"
    },
    "confirm": {
      "title": "Potwierdzenie płatności",
      "savedIbanTitle": "Zapisany IBAN",
      "body": "Użyjemy tego IBAN do przelewu po zakończeniu kontroli jakości Twoich części.",
      "changeIban": "Zmień IBAN"
    },
    "iban": {
      "title": "Dane IBAN",
      "info": "Ten IBAN zostanie użyty do płatności po kontroli jakości Twoich części.",
      "ownerLabel": "Właściciel konta (opcjonalnie)",
      "ibanLabel": "IBAN",
      "helper": "Akceptujemy IBAN w strefie SEPA.",
      "saveAndConfirm": "Zapisz i zatwierdź"
    },
    "common": {
      "cancel": "Anuluj",
      "confirm": "Potwierdź"
    },
    "errors": {
      "invalidIban": "Nieprawidłowy IBAN. Sprawdź format i sumę kontrolną (mod 97).",
      "saveFailed": "Nie można zapisać IBAN."
    },
    "labels": {
      "screen": "Ekran",
      "motherboard": "Płyta główna",
      "battery": "Bateria",
      "camera": "Aparat",
      "speaker": "Głośnik",
      "microphone": "Mikrofon",
      "chargingConnector": "Złącze ładowania",
      "button": "Przycisk",
      "vibrator": "Wibrator",
      "packages": "paczki",
      "kg": "kg",
      "pieces": "szt.",
      "batchSort": "Wyślij, a my posortujemy!"
    }
  },
  "it": {
    "header": {
      "title": "Riepilogo della selezione",
      "subtitle": "Controlla i tuoi articoli prima di procedere."
    },
    "chips": {
      "devices": "Apparecchi:",
      "parts": "Parti:",
      "totalHT": "Totale parziale:"
    },
    "count": {
      "devices": "Apparecchi",
      "parts": "Ricambi",
      "totalItems": "Totale articoli"
    },
    "total": "Totale",
    "empty": {
      "text": "Nessuna selezione in corso.",
      "back": "Torna ai prezzi"
    },
    "table": {
      "aria": "dettagli di sintesi",
      "article": "Articolo",
      "unit": "Unità (€)",
      "qty": "Qty",
      "total": "Totale",
      "typeDevice": "Dispositivo completo",
      "typePart": "Ricambio",
      "totalHT": "Totale parziale"
    },
    "actions": {
      "editSelection": "Modifica la mia selezione",
      "validate": "Conferma"
    },
    "confirm": {
      "title": "Conferma di pagamento",
      "savedIbanTitle": "Salvataggio IBAN",
      "body": "Useremo questo IBAN per fare il trasferimento dopo il controllo di qualità dei vostri articoli.",
      "changeIban": "Cambiare IBAN"
    },
    "iban": {
      "title": "Dettagli IBAN",
      "info": "Questo IBAN sarà utilizzato per il vostro pagamento dopo il controllo di qualità dei vostri articoli.",
      "ownerLabel": "Titolare del conto (opzionale)",
      "ibanLabel": "IBAN",
      "helper": "Accettiamo SEPA IBAN.",
      "saveAndConfirm": "Salvare e confermare"
    },
    "common": {
      "cancel": "Annulla",
      "confirm": "Conferma"
    },
    "errors": {
      "invalidIban": "IBAN non valido. Controllare il formato e il checksum (mod 97).",
      "saveFailed": "Incapace di salvare IBAN."
    },
    "labels": {
      "screen": "Schermo",
      "motherboard": "Scheda madre",
      "battery": "Batteria",
      "camera": "Macchina fotografica",
      "speaker": "Presidente",
      "microphone": "Microfono",
      "chargingConnector": "Connettore di ricarica",
      "button": "Pulsante",
      "vibrator": "Vibratore",
      "packages": "pacchi",
      "kg": "kg",
      "pieces": "pc",
      "batchSort": "Mandalo, lo sistemiamo per te!"
    }
  },
  "de": {
    "header": {
      "title": "Ihre Auswahlzusammenfassung",
      "subtitle": "Überprüfen Sie Ihre Artikel, bevor Sie fortfahren."
    },
    "chips": {
      "devices": "Produkte:",
      "parts": "Teile:",
      "totalHT": "Zwischensumme:"
    },
    "count": {
      "devices": "Geräte",
      "parts": "Ersatzteile",
      "totalItems": "Summe der Posten"
    },
    "total": "Insgesamt",
    "empty": {
      "text": "Keine Auswahl im Gange.",
      "back": "Zurück zum Pricing"
    },
    "table": {
      "aria": "Kurzbeschreibung",
      "article": "Position",
      "unit": "Einheit (€)",
      "qty": "Qty",
      "total": "Gesamt (€)",
      "typeDevice": "Vollständiges Gerät",
      "typePart": "Ersatzteil",
      "totalHT": "Zwischensumme"
    },
    "actions": {
      "editSelection": "Bearbeiten meiner Auswahl",
      "validate": "Bestätigung"
    },
    "confirm": {
      "title": "Zahlungsbestätigung",
      "savedIbanTitle": "Gespeicherte IBAN",
      "body": "Wir werden diese IBAN verwenden, um den Transfer nach der Qualitätskontrolle Ihrer Artikel durchzuführen.",
      "changeIban": "Änderung IBAN"
    },
    "iban": {
      "title": "IBAN Details",
      "info": "Diese IBAN wird für Ihre Zahlung nach der Qualitätskontrolle Ihrer Artikel verwendet.",
      "ownerLabel": "Kontoinhaber (fakultativ)",
      "ibanLabel": "IBAN",
      "helper": "Wir akzeptieren SEPA IBANs.",
      "saveAndConfirm": "Speichern und Bestätigen"
    },
    "common": {
      "cancel": "Stornierung",
      "confirm": "Bestätigung"
    },
    "errors": {
      "invalidIban": "Ungültige IBAN. Überprüfen Sie das Format und die Prüfsumme (mod 97).",
      "saveFailed": "IBAN kann nicht gespeichert werden."
    },
    "labels": {
      "screen": "Bildschirm",
      "motherboard": "Motherboard",
      "battery": "Batterie",
      "camera": "Kamera",
      "speaker": "Sprecher",
      "microphone": "Mikrofon",
      "chargingConnector": "Ladeanschluss",
      "button": "Button",
      "vibrator": "Vibrator",
      "packages": "Pakete",
      "kg": "kg",
      "pieces": "pcs",
      "batchSort": "Schicken Sie es, wir sortieren es für Sie!"
    }
  },
  "pt": {
    "header": {
      "title": "Seu resumo de seleção",
      "subtitle": "Verifique seus itens antes de prosseguir."
    },
    "chips": {
      "devices": "Dispositivos:",
      "parts": "Partes:",
      "totalHT": "Subtotal:"
    },
    "count": {
      "devices": "Dispositivos",
      "parts": "Peças sobressalentes",
      "totalItems": "Total das rubricas"
    },
    "total": "Total",
    "empty": {
      "text": "Nenhuma selecção em progresso.",
      "back": "Voltar aos preços"
    },
    "table": {
      "aria": "detalhes do resumo",
      "article": "Item",
      "unit": "Unidade (€)",
      "qty": "Qty",
      "total": "Total (€)",
      "typeDevice": "Dispositivo completo",
      "typePart": "Peças sobresselentes",
      "totalHT": "Subtotal"
    },
    "actions": {
      "editSelection": "Editar minha seleção",
      "validate": "Confirmar"
    },
    "confirm": {
      "title": "Confirmação do pagamento",
      "savedIbanTitle": "IBAN salvo",
      "body": "Vamos usar este IBAN para fazer a transferência após a verificação de qualidade de seus itens.",
      "changeIban": "Mudar IBAN"
    },
    "iban": {
      "title": "Detalhes do IBAN",
      "info": "Este IBAN será usado para o seu pagamento após a verificação de qualidade de seus itens.",
      "ownerLabel": "Titular da conta (facultativo)",
      "ibanLabel": "IBAN",
      "helper": "Aceitamos IBANs SEPA.",
      "saveAndConfirm": "Salvar e confirmar"
    },
    "common": {
      "cancel": "Cancelar",
      "confirm": "Confirmar"
    },
    "errors": {
      "invalidIban": "IBAN inválido. Verifique o formato e a soma de verificação (mod 97).",
      "saveFailed": "Não foi possível salvar o IBAN."
    },
    "labels": {
      "screen": "Ecrã",
      "motherboard": "Painel principal",
      "battery": "Bateria",
      "camera": "Câmera",
      "speaker": "Alto-falante",
      "microphone": "Microfone",
      "chargingConnector": "Conector de carregamento",
      "button": "Sabor",
      "vibrator": "Vibrações motoras",
      "packages": "parcelas",
      "kg": "kg",
      "pieces": "pcs",
      "batchSort": "Manda-o, nós resolvemos isso para ti!"
    }
  },
  "cs": {
    "header": {
      "title": "Shrnutí Vašeho výběru",
      "subtitle": "Zkontrolujte si věci, než budete pokračovat."
    },
    "chips": {
      "devices": "Zařízení:",
      "parts": "Díly:",
      "totalHT": "Mezisoučet:"
    },
    "count": {
      "devices": "Zařízení",
      "parts": "Náhradní díly",
      "totalItems": "Položky celkem"
    },
    "total": "Celkem",
    "empty": {
      "text": "Neprobíhá žádný výběr.",
      "back": "Zpět k cenám"
    },
    "table": {
      "aria": "Souhrnné údaje",
      "article": "Položka",
      "unit": "Jednotka (€)",
      "qty": "Qty",
      "total": "Celkem (v EUR)",
      "typeDevice": "Kompletní zařízení",
      "typePart": "Náhradní část",
      "totalHT": "Mezisoučet"
    },
    "actions": {
      "editSelection": "Upravit můj výběr",
      "validate": "Potvrdit"
    },
    "confirm": {
      "title": "Potvrzení platby",
      "savedIbanTitle": "Uložené IBAN",
      "body": "Pomocí tohoto IBAN provedeme převod po kontrole kvality Vašich položek.",
      "changeIban": "Změnit IBAN"
    },
    "iban": {
      "title": "Údaje o IBAN",
      "info": "Tento IBAN bude použit pro vaši platbu po kontrole kvality vašich položek.",
      "ownerLabel": "Držitel účtu (nepovinné)",
      "ibanLabel": "IBAN",
      "helper": "Přijímáme SEPA IBANY.",
      "saveAndConfirm": "Uložit a potvrdit"
    },
    "common": {
      "cancel": "Zrušit",
      "confirm": "Potvrdit"
    },
    "errors": {
      "invalidIban": "Neplatný IBAN. Zkontrolujte formát a kontrolní součet (mod 97).",
      "saveFailed": "Nelze uložit IBAN."
    },
    "labels": {
      "screen": "Obrazovka",
      "motherboard": "Základní deska",
      "battery": "Baterie",
      "camera": "Kamera",
      "speaker": "Mluvčí",
      "microphone": "Mikrofon",
      "chargingConnector": "Nabíjecí konektor",
      "button": "Chuť",
      "vibrator": "Vibrationsmotor",
      "packages": "pozemky",
      "kg": "kg",
      "pieces": "ks",
      "batchSort": "Pošli to, my to pro tebe vyřešíme!"
    }
  },
  "nl": {
    "header": {
      "title": "Uw selectieoverzicht",
      "subtitle": "Controleer uw items voordat u verder gaat."
    },
    "chips": {
      "devices": "Apparaten:",
      "parts": "Delen:",
      "totalHT": "Subtotaal:"
    },
    "count": {
      "devices": "Apparaten",
      "parts": "Onderdelen",
      "totalItems": "Totaal posten"
    },
    "total": "Totaal",
    "empty": {
      "text": "Geen selectie in uitvoering.",
      "back": "Terug naar prijzen"
    },
    "table": {
      "aria": "Samenvatting",
      "article": "Post",
      "unit": "Eenheid (€)",
      "qty": "Aantal",
      "total": "Totaal (€)",
      "typeDevice": "Compleet apparaat",
      "typePart": "Reserveonderdeel",
      "totalHT": "Subtotaal"
    },
    "actions": {
      "editSelection": "Mijn selectie bewerken",
      "validate": "Bevestigen"
    },
    "confirm": {
      "title": "Betalingsbevestiging",
      "savedIbanTitle": "Opgeslagen IBAN",
      "body": "We zullen deze IBAN gebruiken om de overdracht na de kwaliteitscontrole van uw items te maken.",
      "changeIban": "IBAN wijzigen"
    },
    "iban": {
      "title": "IBAN-gegevens",
      "info": "Dit IBAN wordt gebruikt voor uw betaling na de kwaliteitscontrole van uw items.",
      "ownerLabel": "Rekeninghouder (facultatief)",
      "ibanLabel": "IBAN",
      "helper": "Wij accepteren SEPA IBANs.",
      "saveAndConfirm": "Opslaan en bevestigen"
    },
    "common": {
      "cancel": "Annuleren",
      "confirm": "Bevestigen"
    },
    "errors": {
      "invalidIban": "Ongeldig IBAN. Controleer het formaat en controlesom (mod 97).",
      "saveFailed": "Kon IBAN niet redden."
    },
    "labels": {
      "screen": "Scherm",
      "motherboard": "Mainboard",
      "battery": "Batterij",
      "camera": "Camera",
      "speaker": "Speaker",
      "microphone": "Microfoon",
      "chargingConnector": "Oplaadconnector",
      "button": "Proef",
      "vibrator": "Trillingsmotor",
      "packages": "pakketten",
      "kg": "kg",
      "pieces": "stuks",
      "batchSort": "Stuur het, we regelen het voor je!"
    }
  }
};

export default recapI18n;
